import { FunctionComponent } from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { Person, Requirement } from '../../types';
import { BatchApiStatusHandler } from '../../components';
import { useBatchApi } from '../../hooks';
import { DelawareAnnualReport } from './DelawareAnnualReport';
import { DefaultAnnualReport } from './DefaultAnnualReport';
import { FatalError } from '../FatalError';

type AnnualReportProps = {
  locationId: string;
  requirement: Requirement;
  peopleData: Person[];
  callbackUrl?: string | null;
};

export const AnnualReportView: FunctionComponent = () => {
  const { locationId: rawLocationId, requirementId } =
    useParams<Record<string, string>>();

  if (!rawLocationId || !requirementId) {
    return <FatalError />;
  }

  const locationId = rawLocationId.toLowerCase();

  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get('callback_url');

  const batchResponse = useBatchApi([
    {
      url: `/api/requirements/${requirementId}`,
      method: 'POST',
    },
    {
      url: '/api/legal_entity/people',
      method: 'GET',
    },
  ]);

  const componentPropsFn = ([
    reqResponse,
    peopleResponse,
  ]: any[]): AnnualReportProps => {
    return {
      locationId,
      requirement: reqResponse,
      peopleData: peopleResponse,
      callbackUrl,
    };
  };

  return (
    <BatchApiStatusHandler
      batchResponse={batchResponse}
      component={
        locationId === 'de' ? DelawareAnnualReport : DefaultAnnualReport
      }
      componentProps={componentPropsFn}
    />
  );
};
